import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

const PriceDifferenceAlert = (props) => {
    const { priceChangePopup, togglePriceDifferencePopUp } = props;

    return (
        <Modal isOpen={priceChangePopup} centered className='cf-payment-status-popup'>
            <ModalHeader toggle={() => togglePriceDifferencePopUp("cancel")} style={{ borderBottom: "none" }}></ModalHeader>
            <ModalBody className="m-auto text-center">
                <div className='c-btn'>
                        <p className="note">Your transaction has crossed the market hours (10AM-5PM Monday to Friday excluding holidays). Hence, the prices have been updated. Kindly re-initiate the transaction the get the latest price.</p>
                       <Button className='btn-retry' onClick={() => togglePriceDifferencePopUp("cancel")}>OK</Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default PriceDifferenceAlert;